module.exports = __webpack_public_path__ + "static/img/new_btn_2.cb2ce98e.png";